import {SEARCH_SELECT_ITEM, DO_SEARCH, SEARCH_ADD_SUGGESTIONS, SET_POINT, 
  CLEAR_POINTS, CLEAR_POINT, EDIT_POINT, EDIT_POINTS_COORDS, CHANGE_POINT_ORDER, DELETE_POINT, UPDATE_ROUTES_DATA, ROUTING_TOGGLE} from './actions';
import {SHOW_POPUP} from '../mapPopup/actions';
import {RECEIVE_RGEO_ADDRESS} from '../reverseGeocoding/actions';

var getSuggestion = function(suggestions, category, index){

  if(typeof suggestions[category] === 'undefined') {

    return;
  }

  if(typeof suggestions[category][index] === 'undefined') {
    
    return;
  }

  suggestions[category][index].category = category;
  
  return suggestions[category][index];
};

const DefaultState = {
  info: {len: 0, time: 0},
  enabled: false,
  isMaxPoints: false,
  drawEnable: false,
  updateGen: 0,
  waypoints: [], //{address: '', coords: [], length: 0, time: 0}
  engine: 'OSRM' //OSRM / JS
};

const MAX_POINTS = 15;

const routing = (state = DefaultState, action) => {
  switch (action.type) {
    case UPDATE_ROUTES_DATA:

        var totalDistance = 0;
        var totalTime = 0;

        if (typeof action.data !== 'undefined') {
          for (var i = action.data.length - 1; i >= 0; i--) {
            totalDistance += action.data[i].distance;
            totalTime += action.data[i].duration;
          }
        }
        
        state.info = {len: totalDistance, time: totalTime};
        
        return Object.assign({}, state);
    case RECEIVE_RGEO_ADDRESS:

      var waypoints = [];

      for (var i = 0, len = state.waypoints.length; i < len; i++) {
        let waypoint = state.waypoints[i];

        if(waypoint.coords[0] === action.coords[0] && waypoint.coords[1] === action.coords[1]) {
          waypoint.address = action.address;
        }

        waypoints.push({address: waypoint.address, coords: [waypoint.coords[0], waypoint.coords[1]]});
      }
      
      var genInt = parseInt(Math.random() * 10000);
      
      return Object.assign({}, state, {waypoints: waypoints, updateGen: genInt});
      break;
    case ROUTING_TOGGLE: 
      
      if(typeof action.data !== 'undefined'){
        state.enabled = action.data;
      } else {
        state.enabled = !state.enabled;
      }
      
      if(!state.enabled) {
        state.waypoints = [];
        state.info = {len: 0, time: 0};
      }
      
      return Object.assign({}, state);
    case SET_POINT:

      var waypoints = [].concat(state.waypoints);
      let isMaxPoints = false;

      waypoints.push({address: null, coords: [parseFloat(action.data[0].toFixed(2)), parseFloat(action.data[1].toFixed(2))]});

      if (waypoints.length >= MAX_POINTS) {
        isMaxPoints = true;
      }
      
      state.waypoints = waypoints;
      state.enabled = true;
      state.isMaxPoints = isMaxPoints;

      return Object.assign({}, state);
    case EDIT_POINT: 

      var waypoints = [].concat(state.waypoints);
      waypoints[action.index] = action.coords;

      state.waypoints = waypoints;

      return Object.assign({}, state);
    case DELETE_POINT:
      var waypoints = state.waypoints.slice();
      const pointToRemove = action.data.index;
      
      waypoints.splice(pointToRemove, 1);
      
      return Object.assign({}, state, {waypoints: waypoints});
    case CHANGE_POINT_ORDER: 

         var waypoints = state.waypoints.slice();
         var lastIndex = waypoints.length - 1;
 
        var replaceIndex = action.data.newIndex;//(action.data.direction == "UP" ? action.data.index - 1 : action.data.index + 1); 
        if(replaceIndex > lastIndex || replaceIndex < 0) {
          return state;
        }
        
        var replaceEntry = waypoints[replaceIndex];
        var selectedEntry = waypoints[action.data.oldIndex];

        waypoints[replaceIndex] = selectedEntry;
        waypoints[action.data.oldIndex] = replaceEntry;

        return Object.assign({}, state, {waypoints: waypoints});
    case EDIT_POINTS_COORDS:

      var waypoints = state.waypoints.slice();

      for (var i = 0, len = waypoints.length; i < len; i++) {

        if(waypoints[i].coords[0] !== action.data[i][0] || waypoints[i].coords[1] !== action.data[i][1]) {
          
          waypoints[i].coords = [parseFloat(action.data[i][0].toFixed(2)), parseFloat(action.data[i][1].toFixed(2))]; 
        }
      }

      return Object.assign({}, state, {waypoints: waypoints});
    case CLEAR_POINTS:

      state.waypoints = [];
      state.info = {len: 0, time: 0};
      state.isMaxPoints = false;

      return Object.assign({}, state);
    case CLEAR_POINT:


      state.waypoints.splice(action.data, 1);
      return Object.assign({}, state);
    default:
      return state;
  }
};

export {routing};


// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/routing/reducer.js